export const getUserPermissions = () => {
  let application = localStorage.getItem('application')
  return JSON.parse(application)
}
